export class ProductUseItem {
	pk: string; //product_name
	sk: string; //venueKey_useDateTimeUnix

	useKey: string;
	venueKey: string;
	useDateTime: number;
	product: string;
	userAgent: any;
	isMobile: boolean;
	cartItemAdded: boolean;
	cartItemAddedDateTime: number;
	transactionComplete: boolean;
	checkKey: string;
	transactionCompleteDateTime: number;

	browser: string;
	browser_version: string;
	device: string;
	deviceType: string;
	orientation: string;
	os: string;
	os_version: string;
	platformId: string;
	reTree: string;
	ua: string;
	deviceDetail: any;

	public constructor(init?: Partial<ProductUseItem>) {
		Object.assign(this, init);
	}
}
